import { useContext, useMemo } from "react";
import { Frame, useEditor, Element } from "@craftjs/core";
import Scrollbars from "react-custom-scrollbars-2";
import { Style } from "react-style-tag";
import Header from "../Header";
import Toolbox from "../Toolbox/Toolbox";
import { Box, ButtonProps, Stack } from "@mui/material";
import Settings from "../Settings/Settings";
import { Template, Website, WebsiteElement } from "@/types";
import ContainerBlock from "@/components/editor/blocks/ContainerBlock";
import OrganizationThemeProvider from "@/providers/OrganizationThemeProvider";
import { EditorContext } from "../../Editor";
import "./ViewPort.scss";

export interface Props {
  title: string;
  data: string;
  actions?: ButtonProps[];
  template: Template;
  website?: Website;
  styles: string;
  json?: string;
  elements: WebsiteElement[] | null;
  onSave: (data: string, elementId?: string) => void;
  onClose: () => void;
}

const ViewPort = (props: Props) => {
  const { connectors } = useEditor();
  const { viewPort } = useContext(EditorContext);

  const viewportWidth = useMemo(() => {
    if (props.template?.type === "menu") {
      return "600px !important";
    }

    switch (viewPort) {
      case "sm":
        return "500px !important";
      case "md":
        return "700px !important";
      default:
        return "100% !important";
    }
  }, [props.template?.type, viewPort]);

  const rawStyles = props.styles ?? props.website?.styles ?? props.template?.styles ?? "";
  const processedStyles = useMemo(() => {
    if (!rawStyles) return "";
    return rawStyles.replace(/@media\s*\(/g, "@container (");
  }, [rawStyles]);

  return (
    <div className="editor">
      <div className="editor__header">
        <Header {...props} />
      </div>
      <div className="editor__body">
        <Toolbox />
        <Scrollbars autoHide>
          <div className="editor__canvas" ref={(ref: any) => ref && connectors.select(connectors.hover(ref, null as any), null as any)}>
            <Stack spacing={2} my={2} flex={1} alignItems="center">
              <Box
                className="viewport"
                id="main-container"
                ref={(ref: any) => ref && connectors.select(connectors.hover(ref, null as any), null as any)}
                sx={{
                  width: viewportWidth,
                  transition: "width 0.25s",
                  containerType: "inline-size",
                }}
              >
                <Style children={processedStyles} />
                <OrganizationThemeProvider>
                  <Frame data={props.json}>
                    <Element canvas is={ContainerBlock} custom={{ displayName: "App" }}></Element>
                  </Frame>
                </OrganizationThemeProvider>
              </Box>
            </Stack>
          </div>
        </Scrollbars>
        <Settings onSave={props.onSave} />
      </div>
    </div>
  );
};

export default ViewPort;
